import "./polyfills";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./App.css";
import init, { Session, UUID, UserCommandResponseVec } from "keyserver-client";

// Ensure the WASM module is initialized before rendering the app.
init().then(() => {
  const root = ReactDOM.createRoot(document.getElementById("root")!);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}).catch((err) => {
  console.error("WASM module initialization failed:", err);
});